import { FC } from 'react'

import { QBRSectionThatCanBeDisabled } from 'partner360/components/QBR/shared/qbrSectionThatCanBeDisabled/QBRSectionThatCanBeDisabled'

import { SettingsStep } from '../steps/settingsStep/SettingsStep'

import { QbrAttachmentsWrapper } from './components/qbrAttachmentsWrapper/QbrAttachmentsWrapper'

interface IQbrLegacyDocumentStepRenderProps {
  currentStep: number
  showListOfAllDocuments: () => void
  onSave?: () => void
}

export const QbrLegacyDocumentStepRender: FC<IQbrLegacyDocumentStepRenderProps> = ({
  currentStep,
  showListOfAllDocuments,
  onSave,
}) => {
  switch (currentStep) {
    case 1: {
      return (
        <QBRSectionThatCanBeDisabled>
          <SettingsStep isQbrLegacyDocumentMode showListOfAllDocuments={showListOfAllDocuments} />
        </QBRSectionThatCanBeDisabled>
      )
    }
    case 2: {
      return <QbrAttachmentsWrapper onSave={onSave} />
    }
    default: {
      return <div> not found</div>
    }
  }
}
